export const CHANGE_LOGO = '[logo] change logo'

export function changeLogo(imageSrc) {
  return {
    type: CHANGE_LOGO,
    state: {
      imageSrc,
    },
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/store/logo/logo.actions.js